// @core/api/endpoints/authn/update_oauth2_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  OAuth2ProviderResponse,
  UpdateOAuth2ProviderRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Update OAuth2 provider
 * Updates configuration for an OAuth2 identity provider including name, endpoints, and scopes. Leave client_secret empty to preserve the existing value.
 */
export async function UpdateOAuth2Provider(
  provider_id: string,
  data: UpdateOAuth2ProviderRequest,
  options?: RequestOptions
): Promise<OAuth2ProviderResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/oauth2/providers/:provider_id`;
  requestPath = requestPath.replace(':provider_id', encodeURIComponent(provider_id));
  const requestOptions = options;
  return client.put<OAuth2ProviderResponse>(requestPath, data, requestOptions);
}
